import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class AuthenticationService implements CanActivate {
	
  constructor(private router: Router) { 
	
  }
  
  canActivate(): boolean {
	let user = localStorage.getItem('user_profile');
  	var errorMessage:string;
	if (user){
		let userProfile = JSON.parse(user);
		if(userProfile && userProfile.role != undefined){
			if(userProfile.role.name == "member"){
				return true;
			}else{
				errorMessage = "Invalid Role.";
			}
		}else{
			errorMessage = "Not Logged In.";

		}
		
    }else{
		errorMessage ="Not Logged In.";
	}
	
	
	this.router.navigate(['signin']);
	return false;
  }
  
  
}

